export default __webpack_public_path__ + "static/media/smashuplogo2.4ebead28.svg";